<!-- 银行流水卡片列表 -->
<template>
    <a-card title="银行发放流水">
        <div class="steps-info">
            <p><b>工资月：</b>{{ commonParams.attendanceMonthDesc }}</p>
            <p><b>流水总金额：</b>{{ detail.totalAmount }}</p>
        </div>
        <a-card title="流水明细" size="small">
            <custom-table
                row-key="id"
                size="middle"
                :pagination="pagination"
                :loading="loading"
                :scroll="scrollConfig"
                :columns="bankListColumns"
                :data-source="dataList"
            />
        </a-card>
    </a-card>
</template>

<script>
import { Card as ACard } from 'ant-design-vue'
import CustomTable from '@components/CustomTable'
import initTable from '@mixins/initTable'

import { BANK_LIST_COLUMNS } from './config'
import { getBankFlowInfoPage, getBankFlowInformationTotalAmount } from '@/service/project/attendanceAndSalaryServices'

export default {
    name: 'BankCard',
    components: {
        CustomTable,
        ACard
    },
    mixins: [initTable],
    props: {
        commonParams: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            detail: {},
            bankListColumns: BANK_LIST_COLUMNS,
            scrollConfig: Object.freeze({
                x: 1000,
                y: 500
            }),
            loading: false
        }
    },
    mounted() {
        this.getInfo()
    },
    methods: {
        async getInfo() {
            try {
                this.loading = true
                const result = await getBankFlowInformationTotalAmount({
                    projectCode: this.commonParams.projectCode,
                    bankFlowMonthDesc: this.commonParams.attendanceMonthDesc
                })
                this.detail = result
            } catch (e) {
                this.$message.error(e.message)
            } finally {
                this.loading = false
            }
        },
        // 获取分页列表数据
        async getList() {
            try {
                this.loading = true

                const result = await getBankFlowInfoPage({
                    projectCode: this.commonParams.projectCode,
                    bankFlowMonthDesc: this.commonParams.attendanceMonthDesc,
                    ...this.params
                })

                this.total = result.total || 0
                this.dataList = result.records || []
            } catch (e) {
                this.$message.error(e.message)
            } finally {
                this.loading = false
            }
        }
    }
}
</script>
